import React from 'react';
import { motion } from 'framer-motion';

const DATE_TYPES = [
  { id: 'coffee', label: 'Coffee', emoji: '☕' },
  { id: 'dinner', label: 'Dinner', emoji: '🍽️' },
  { id: 'lunch', label: 'Lunch', emoji: '🥐' },
  { id: 'custom', label: 'Custom', emoji: '✨' },
];

const InviteDateType = ({ selected, customValue, onSelect, onCustomChange, onContinue }) => {
  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="w-full max-w-sm p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">What sounds good?</h2>
      <p className="text-gray-500 text-sm mb-6 text-center">Choose what you'd like to do</p>
      <div className="grid grid-cols-2 gap-3 mb-6">
        {DATE_TYPES.map((dt) => (
          <button
            key={dt.id}
            onClick={() => onSelect(dt.id)}
            className={`p-5 rounded-2xl flex flex-col items-center gap-2 border-2 transition-all
              ${selected === dt.id ? 'border-pink-500 bg-pink-50' : 'border-transparent bg-white shadow-sm hover:shadow-md'}`}
          >
            <span className="text-3xl">{dt.emoji}</span>
            <span className="font-medium text-sm text-gray-700">{dt.label}</span>
          </button>
        ))}
      </div>
      {selected === 'custom' && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} className="mb-6">
          <input
            type="text" value={customValue} onChange={(e) => onCustomChange(e.target.value)}
            placeholder="e.g. Movie, Beach, Walk, Drinks..."
            className="w-full p-4 rounded-xl border border-gray-200 focus:border-pink-500 focus:ring-2 focus:ring-pink-100 outline-none"
          />
        </motion.div>
      )}
      <button
        onClick={onContinue}
        disabled={!selected || (selected === 'custom' && !customValue)}
        className="w-full bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-pink-200 disabled:opacity-50"
      >
        Continue →
      </button>
    </motion.div>
  );
};

export default InviteDateType;